// export default ProductMap = {
exports.ProductMap = {
  11: {
    '2kWh': [
    // {
    //     name: 'Get Set Kit (2kWh)',
    //     pid: '7563402117318',
    //     varId: '42172092448966',
    //     adaptBatCap: 2,
    //     limit: 2,
    //     off_price: '6897',
    //     old_price: '6897',
    //     // save_money: '600',
    //     imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
    //     detailImgList: ['power-2kw.jpg', 'wire.jpg'],
    //     desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
    // },
    // {
    //     name: 'Prepared Kit (2kWh)',
    //     pid: '7563402117318',
    //     varId: '42172092481734',
    //     adaptBatCap: 2,
    //     limit: 2,
    //     off_price: '7597',
    //     old_price: '7597',
    //     // save_money: '700',
    //     imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
    //     detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
    //     desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
    // },
    {
      name: 'Independence Kit (2kWh)',
      pid: '7563402117318',
      varId: '42172092514502',
      adaptBatCap: 2,
      limit: 2,
      off_price: '7897',
      old_price: '7897',
      // save_money: '900',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      buy_link: 'https://ecopowerworld.com.au/?product=ecoflow-2kwh-power-kits',
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '4kWh': [
    // {
    //     name: 'Get Set Kit (4kWh)',
    //     pid: '7563403460806',
    //     varId: '42172093857990',
    //     adaptBatCap: 2,
    //     limit: 1,
    //     off_price: '9896',
    //     old_price: '9896',
    //     // save_money: '900',
    //     imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack'],
    //     detailImgList: ['power-4kw.jpg', 'wire.jpg'],
    //     desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
    // },
    // {
    //     name: 'Prepared Kit (4kWh)',
    //     pid: '7563403460806',
    //     varId: '42172093890758',
    //     adaptBatCap: 2,
    //     limit: 1,
    //     off_price: '10596',
    //     old_price: '10596',
    //     // save_money: '1000',
    //     imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
    //     detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
    //     desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
    // },
    {
      name: 'Independence Kit (4kWh)',
      pid: '7563403460806',
      varId: '42172093923526',
      adaptBatCap: 2,
      limit: 1,
      off_price: '10896',
      old_price: '10896',
      // save_money: '1200',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      buy_link: 'https://ecopowerworld.com.au/?product=ecoflow-4kwh-power-kits',
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '5kWh': [
    // {
    //     name: 'Get Set Kit (5kWh)',
    //     pid: '7563403493574',
    //     varId: '42172093956294',
    //     adaptBatCap: 5,
    //     limit: 2,
    //     off_price: '10397',
    //     old_price: '10397',
    //     // save_money: '1100',
    //     imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
    //     detailImgList: ['power-5kw.jpg', 'wire.jpg'],
    //     desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
    // },
    // {
    //     name: 'Prepared Kit (5kWh)',
    //     pid: '7563403493574',
    //     varId: '42172093989062',
    //     adaptBatCap: 5,
    //     limit: 2,
    //     off_price: '11097',
    //     old_price: '11097',
    //     // save_money: '1200',
    //     imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
    //     detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
    //     desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
    // },
    {
      name: 'Independence Kit (5kWh)',
      pid: '7563403493574',
      varId: '42172094021830',
      adaptBatCap: 5,
      limit: 2,
      off_price: '11397',
      old_price: '11397',
      // save_money: '1400',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      buy_link: 'https://ecopowerworld.com.au/?product=ecoflow-5kwh-power-kits',
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '10kWh': [
    // {
    //     name: 'Get Set Kit (10kWh)',
    //     pid: '7563403559110',
    //     varId: '42172094087366',
    //     adaptBatCap: 5,
    //     limit: 1,
    //     off_price: '16896',
    //     old_price: '16896',
    //     // save_money: '1500',
    //     imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack'],
    //     detailImgList: ['power-10kw.jpg', 'wire.jpg'],
    //     desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
    // },
    // {
    //     name: 'Prepared Kit (10kWh)',
    //     pid: '7563403559110',
    //     varId: '42172094152902',
    //     adaptBatCap: 5,
    //     limit: 1,
    //     off_price: '17596',
    //     old_price: '17596',
    //     // save_money: '1700',
    //     imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
    //     detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
    //     desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
    // },
    {
      name: 'Independence Kit (10kWh)',
      pid: '7563403559110',
      varId: '42172094185670',
      adaptBatCap: 5,
      limit: 1,
      off_price: '17896',
      old_price: '17896',
      // save_money: '1900',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      buy_link: 'https://ecopowerworld.com.au/?product=ecoflow-10kwh-power-kits',
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '15kWh': [
    // {
    //     name: 'Get Set Kit (15kWh)',
    //     pid: '7563403591878',
    //     varId: '42172094316742',
    //     off_price: '23395',
    //     old_price: '23395',
    //     // save_money: '1900',
    //     imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack'],
    //     detailImgList: ['power-15kw.jpg', 'wire.jpg'],
    //     desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
    // },
    // {
    //     name: 'Prepared Kit (15kWh)',
    //     pid: '7563403591878',
    //     varId: '42172094349510',
    //     off_price: '24095',
    //     old_price: '24095',
    //     // save_money: '2200',
    //     imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
    //     delivery_date: 'Early Augest 2022',
    //     accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Strap'],
    //     detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
    //     desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
    // },
    {
      name: 'Independence Kit (15kWh)',
      pid: '7563403591878',
      varId: '42172094382278',
      off_price: '24395',
      old_price: '24395',
      // save_money: '2400',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '3x Battery Mounting Strap'],
      buy_link: 'https://ecopowerworld.com.au/?product=ecoflow-15kwh-power-kits',
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }]
  }
};
exports.solarPanelMap = {
  11: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '7563461951686',
    varId: '42172159131846',
    old_price: '499',
    off_price: '499',
    // save_money: '100',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '7563463327942',
    varId: '42172160409798',
    old_price: '1599',
    off_price: '1599',
    // save_money: '100',
    tips: '*This item excludes free shipping.',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*400W Portable Solar Panel',
    pid: '7238909657286',
    varId: '42172348661958',
    old_price: '1599',
    off_price: '1599',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  11: [{
    name: '2kWh LFP Battery',
    pid: '7563470078150',
    varId: '42172168339654',
    off_price: '2999',
    old_price: '2999',
    // save_money: '100',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery',
    pid: '7563470078150',
    varId: '42172168372422',
    off_price: '6499',
    old_price: '6499',
    // save_money: '200',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  11: {
    pid: '7598187413702',
    varId: '42210557034694',
    off_price: '0',
    old_price: '0',
    save_money: '0'
  }
};
exports.ConsoleMap = {
  11: []
};
exports.ShopifyUrl = 'https://au.ecoflow.com/';